<template>
    <div class="text-input">
        <!-- we need **.lazy** for v-focus to prevent losing focus after @input -->
        <textarea
            v-autoexpand-height
            autofocus
            aria-label="Your answer to the question"
            :class="borderClass"
            :value="props.modelValue"
            @input="emit('update:modelValue', $event?.target?.value)"
            @keypress="onKeyPress"
        />
        <button
            type="submit"
            aria-label="Submit Answer"
            :disabled="!modelValue"
            @click="submitReplyText"
        >
            <img
                src="../../../assets/img/Icons/White/plane.svg"
                alt=""
                role="presentation"
            />
        </button>
    </div>
</template>

<script lang="ts" setup>
interface Props {
    modelValue: string
    shouldFocus?: boolean
    borderClass?: string
}

const props = withDefaults(defineProps<Props>(), {
    shouldFocus: false,
    borderClass: 'grey',
})

const emit = defineEmits(['submitReplyText', 'update:modelValue'])

const submitReplyText = (evt) => {
    evt.preventDefault()
    emit('submitReplyText', evt.target.value)
}

const onKeyPress = (evt) => {
    if (evt.keyCode === 13 && evt.shiftKey) {
        submitReplyText(evt)
    }
}
</script>

<style lang="less">
// Note that this component relies on the coloring and styles defined in conversational.html, brand color below
// is functionally a fallback.
@brandColor: #666;
@errorRed: #ff4c3b;

.text-input {
    position: relative;
    text-align: right;
    padding: 5px;

    &:after {
        content: '';
        display: table;
        clear: both;
    }

    textarea {
        padding: 12px 60px 12px 20px;
        border-radius: 20px;
        min-width: 250px;
        max-width: 90%;
        resize: none;
        font-family: Arial, Helvetica, sans-serif;
        color: #bbb;
        font-size: 1em;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            display: none;
        }

        &:focus {
            outline: none;
            border: 1px solid @brandColor;
            color: #000;
        }

        &.grey {
            border: 1px solid #bbb;
        }

        &.red {
            border: 1px solid @errorRed;
        }
    }
    button {
        position: absolute;
        background-color: @brandColor;
        border: none;
        width: 32px;
        height: 32px;
        border-radius: 16px;
        z-index: 1;
        bottom: 20px;
        right: 16px;
        cursor: pointer;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.3s;

        img {
            width: 18px;
            margin-top: 2px;
            display: inline-block;
        }

        &:focus {
            outline: none;
        }

        &:disabled {
            background-color: #d6d6d6;
        }
    }
}

/* Desktop overrides */
@media only screen and (min-width: 600px) {
    .text-input {
        textarea {
            padding: 15px 60px 15px 30px;
            border-radius: 30px;
            font-size: 1em;
            width: 480px;
        }
        button {
            bottom: 17px;
            right: 16px;
        }
    }
}

/* IE 10+ rules */
@media screen\0 {
    .text-input {
        button {
            bottom: 14px;
            right: 14px;
        }
    }
}
</style>
